export default  {
  hello: '120px',
  title:'36px',
  subtitle:'26px',
  header: '18px',
  paragraph: '16px'
}